/* LL Medico — preview draft only. Two small PDP layout fixes for the white-block
   design:
   1. The "Frequently Bought Together" app (cbb) injects its widget INSIDE the main
      product section's container. Lift it into its own .llm-fbt-block so it sits
      between the buy section and the description (it floats on the warm bg — no card).
   2. The theme renders a standalone "Customer Reviews" heading section ABOVE the
      reviews app block, so it lands outside the reviews white card. Pull it inside
      the reviews card so the heading and reviews read as one block.
   Both survive late app injection / variant re-renders via a MutationObserver. */
(function () {
  function relocateFBT() {
    var desc = document.querySelector('.llm-product-description');
    if (!desc) return;
    var stray = document.querySelector('.cc-main-product .cbb-frequently-bought-container');
    if (!stray) return;
    var block = document.querySelector('.llm-fbt-block');
    if (!block) {
      block = document.createElement('div');
      block.className = 'shopify-section llm-fbt-block';
      var inner = document.createElement('div');
      inner.className = 'container';
      block.appendChild(inner);
      desc.parentNode.insertBefore(block, desc);
    }
    block.querySelector('.container').appendChild(stray);
  }

  function moveReviewsHeading() {
    var revC = document.querySelector('.cc-apps > .section > .container');
    if (!revC) return;
    var headings = document.querySelectorAll('h2.llm-product-description__heading');
    for (var i = 0; i < headings.length; i++) {
      var h = headings[i];
      if (!/customer reviews/i.test(h.textContent || '')) continue;
      if (revC.contains(h)) return; // already moved
      var oldSection = h.closest('.shopify-section');
      revC.insertBefore(h, revC.firstChild);
      if (oldSection && oldSection !== document.querySelector('.cc-apps')) {
        oldSection.style.display = 'none';
      }
      return;
    }
  }

  function anchorHeart() {
    // The favorites heart (.llm-photo-heart) is a sibling of the image gallery
    // inside .product-media, and relies on .product-media being its positioning
    // context. On mobile that context is lost (the slider collapses its box), so
    // the absolute heart escapes to the page top (onto the trust bar). Move it
    // INTO the image viewer, which is reliably position:relative on every
    // viewport, so top/right always anchor it to the product image.
    var heart = document.querySelector('.llm-photo-heart');
    if (!heart) return;
    var anchor = document.querySelector('.media-gallery__viewer')
      || document.querySelector('.media-gallery');
    if (!anchor || heart.parentElement === anchor) return;
    anchor.appendChild(heart);
  }

  function run() { relocateFBT(); moveReviewsHeading(); anchorHeart(); }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  try {
    var obs = new MutationObserver(run);
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 12000);
  } catch (e) {}
})();
